import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  setExportTableData as setExportTableDataAction,
  setIsMapDataLoading as setIsMapDataLoadingAction,
  setPoiImageData as setPoiImageDataAction,
  selectExportTableData,
  selectIsMapDataLoading,
  selectPoiImageData
} from '../slices/exportSlice'

export const useExport = () => {
  const dispatch = useDispatch()

  const exportTableData = useSelector(selectExportTableData)
  const isMapDataLoading = useSelector(selectIsMapDataLoading)
  const poiImageData = useSelector(selectPoiImageData)

  const setExportTableData = useCallback(
    (data) => {
      dispatch(setExportTableDataAction(data))
    },
    [dispatch]
  )

  const setIsMapDataLoading = useCallback(
    (loading) => {
      dispatch(setIsMapDataLoadingAction(loading))
    },
    [dispatch]
  )

  const setPoiImageData = useCallback(
    (data) => {
      dispatch(setPoiImageDataAction(data))
    },
    [dispatch]
  )

  return {
    exportTableData,
    setExportTableData,
    isMapDataLoading,
    setIsMapDataLoading,
    poiImageData,
    setPoiImageData
  }
}
